/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useMemo, useState } from "react";
import { Entity } from "cms/entity/entity";
import { isStringNotEmpty } from "utils/empty-exists";
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { getEntitySchema } from "cms/entity/get-entity-schema";

const EntityItemDisplay = (props) => {
    const { token } = useAuth();
    const value = props?.value;
    // entity schemas state
    const [entitySchemas, setEntitySchemas] = useState(null);
    // entity state
    const [entity, setEntity] = useState(null);
    const entity_guid = useMemo(() => {
        return value;
    }, [value]);

    const type = entity?.type;
    const schema = getEntitySchema(entitySchemas, type);
    
    useEffect(() => {
        const loadEntityData = async () => {
            // TODO: load entity schemas once at startup
            const _schema = await SimpliCityAdminSDK.entity.schemas.find(token);
            setEntitySchemas(_schema);

            if (isStringNotEmpty(entity_guid)) {
                const _entity = await SimpliCityAdminSDK.entity.findOne(token, entity_guid);
                setEntity(_entity);
            }
        };
        loadEntityData();

    }, [token, entity_guid]);
    return (
        <>
            <Entity
                entity={entity}
                schema={schema}
            />
        </>
    );
};
EntityItemDisplay.displayName = "EntityItemDisplay";
export { EntityItemDisplay };
